var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30.6,
    height: 24,
    fill: "none",
    viewBox: "0 0 30.6 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29.6 12v-11h-28.6v22h14.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.6 19.334h-10.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.025 15.666 3.575 3.6666-3.575 3.6666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1 1 14.3 11 14.3-11"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.97dcbeedadfb7a8734fce165b27d850f.svg";
export { ForwardRef as ReactComponent };